/** @jsxRuntime classic */
/** @jsx jsx */
import { jsx, Box, Text, Flex } from 'theme-ui'
import RichTextRender from '/components/Commons/RichTextRender'

import styles from './styles'

const EventGuideSection = ({ csmContent }) => {
  return (
    <Box sx={styles.container}>
      <Box sx={styles.eventGuideWrapper}>
        <Text as="h2" sx={styles.eventGuideWrapper.title}>
          {csmContent?.title}
        </Text>
        <Flex sx={styles.eventGuideWrapper.eventsWrapper}>
          <Box sx={styles.eventGuideWrapper.event}>
            <RichTextRender htmlCode={csmContent?.eventDuration} />
          </Box>
          <Box sx={styles.eventGuideWrapper.event}>
            <RichTextRender htmlCode={csmContent?.eventWinner} />
          </Box>
          <Box sx={styles.eventGuideWrapper.event}>
            <RichTextRender htmlCode={csmContent?.eventWinnerConfirmation} />
          </Box>
          <Box sx={styles.eventGuideWrapper.event}>
            <RichTextRender htmlCode={csmContent?.howToApply} />
          </Box>
        </Flex>
      </Box>
    </Box>
  )
}

export default EventGuideSection
